module.exports = "/lucky-balls/img/bonus_yellow/check_infoBar/check_006.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_yellow/check_infoBar/check_006.png
// module id = 951
// module chunks = 0